import { Card, CardHead, Empty, Icon, Skeleton, rupees } from "./parts";

const STORE_COLORS = { amazon: "var(--acc)", flipkart: "var(--acc-mid)" };

// All-time split between Amazon.in and Flipkart, from both spending summaries.
export function StoreMix({ loading, summaries, onSwitch }) {
  const amounts = {
    amazon: summaries?.amazon?.totalAmountSpent || 0,
    flipkart: summaries?.flipkart?.totalAmountSpent || 0,
  };
  const sum = amounts.amazon + amounts.flipkart;
  const stores = [
    { key: "amazon", name: "Amazon.in" },
    { key: "flipkart", name: "Flipkart" },
  ];

  return (
    <Card style={{ display: "flex", flexDirection: "column" }}>
      <CardHead>
        <span>Where you shop</span>
        <span style={{ fontSize: 11.5, color: "var(--ink3)" }}>All time</span>
      </CardHead>
      {loading ? (
        <Skeleton $h={80} />
      ) : !sum ? (
        <Empty icon="storefront" title="No orders yet">
          Calculate your spend with the extension on Amazon.in or Flipkart.
        </Empty>
      ) : (
        <>
          <div style={{ display: "flex", height: 12, borderRadius: 6, overflow: "hidden", gap: 2, background: "var(--surface2)" }}>
            {stores.map(({ key }) =>
              amounts[key] ? (
                <div key={key} style={{ width: `${(amounts[key] / sum) * 100}%`, background: STORE_COLORS[key] }} />
              ) : null
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", marginTop: 10 }}>
            {stores.map(({ key, name }) => (
              <button
                key={key}
                onClick={() => onSwitch(key)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 0",
                  border: 0,
                  borderTop: "1px solid var(--line)",
                  background: "none",
                  textAlign: "left",
                }}
              >
                <span style={{ width: 10, height: 10, borderRadius: 2, background: STORE_COLORS[key] }} />
                <span style={{ flex: 1, fontSize: 13 }}>
                  {name}{" "}
                  <span style={{ fontWeight: 600 }}>{Math.round((amounts[key] / sum) * 100)}%</span>
                </span>
                <span style={{ fontSize: 13, fontWeight: 600 }}>
                  {amounts[key] ? rupees(amounts[key]) : <span style={{ color: "var(--ink3)", fontWeight: 400 }}>Not calculated</span>}
                </span>
                <Icon name="chevron_right" size={18} style={{ color: "var(--ink3)" }} />
              </button>
            ))}
          </div>
        </>
      )}
    </Card>
  );
}

// The user's three most expensive items (/product → topOrderedProducts).
export function TopPurchases({ loading, products, platformName }) {
  return (
    <Card>
      <CardHead>
        <span>Biggest purchases</span>
        <span style={{ fontSize: 11.5, color: "var(--ink3)" }}>{platformName}</span>
      </CardHead>
      {loading ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} $h={44} />
          ))}
        </div>
      ) : !products?.length ? (
        <Empty icon="shopping_bag" title="Nothing to show yet">
          Your most expensive {platformName} items appear here after you calculate.
        </Empty>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {products.map((product, i) => (
            <a
              key={i}
              href={product.productUrl || undefined}
              target="_blank"
              rel="noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "9px 0",
                borderTop: i ? "1px solid var(--line)" : 0,
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <span
                style={{
                  width: 44,
                  height: 44,
                  flex: "none",
                  borderRadius: 9,
                  border: "1px solid var(--line)",
                  background: "#fff",
                  display: "grid",
                  placeItems: "center",
                  overflow: "hidden",
                }}
              >
                {product.productImageUrl ? (
                  <img src={product.productImageUrl} alt="" style={{ maxWidth: "86%", maxHeight: "86%", objectFit: "contain" }} />
                ) : (
                  <Icon name="inventory_2" size={20} style={{ color: "var(--ink3)" }} />
                )}
              </span>
              <span
                style={{
                  flex: 1,
                  minWidth: 0,
                  fontSize: 12.5,
                  lineHeight: 1.35,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {product.productName}
              </span>
              <span style={{ fontSize: 13, fontWeight: 600, flex: "none" }}>{rupees(product.productPrice)}</span>
            </a>
          ))}
        </div>
      )}
    </Card>
  );
}
